(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.embed.provider.embed-ugc-api'

  require('angular')
    .module(MODULE_NAME, [
      require('../../api/async')
    ])
    .provider('EmbedUgcApi', embedUgcApiProvider)

  function embedUgcApiProvider () {
    return {
      $get: embedUgcApiService
    }
  }

  embedUgcApiService.$inject = ['SdkConfig', 'ThismomentAsyncApi']
  function embedUgcApiService (SdkConfig, ThismomentAsyncApi) {
    var API = ThismomentAsyncApi.configureResource(SdkConfig.get('content_cloud_url') + '/api/solution/v1/embed-ugc-submit')

    return {
      post: postUgc
    }

    function postUgc (embedId, accountId, groupId, data) {
      var postBody = {
        id: embedId,
        a: accountId,
        g: groupId,
        data: data
      }

      return API.post({}, postBody)
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/embed/provider/embed-ugc-api.js